import Layout from "../layout/Layout";
import React, {useEffect} from 'react';
import {useSearchParams} from 'react-router-dom';
import Button from "@amzn/awsui-components-react/polaris/button";
import Flashbar from "@amzn/awsui-components-react/polaris/flashbar"
import Spinner from "@amzn/awsui-components-react/polaris/spinner";
import {
    STATION_SIMULATION_SUMMARY_TABLE_COLUMN_DEFINITIONS,
    STATION_SIMULATION_SUMMARY_TABLE_FILTER_PROPERTIES,
    STATION_SIMULATION_SUMMARY_TABLE_VISIBLE_CONTENT_OPTIONS,
    PAGE_SIZE_OPTIONS
} from "../../utils/mapReleaseDashboard/stationSimulationSummaryTableConfig";
import ComplexFilterTable from "../offline-maps/ComplexFilterTable";
import {useMapReleaseStore} from "../../store/MapReleaseStore";
import { downloadData } from "../../utils/tableConfig";

const StationSimulationSummary = () => {
    const [searchParams] = useSearchParams();
    const mapPackSummaryId = searchParams.get("id")

    const activeValidationDataFetchStatus = false;

    const fetchStationSimulationSummary = useMapReleaseStore(
        (state) => state.fetchStationSimulationSummary
    );
    const isSimulationSummaryInvalid = useMapReleaseStore(
        (state) => state.getInvalidStationSimulationSummary()
    );
    const stationSimulationData: any[] = useMapReleaseStore(
        (state) => state.getStationSimulationData()
    );
    const isStationSimulationLoaded: boolean = useMapReleaseStore(
        (state) => state.isStationSimulationLoaded()
    );

    // Downloading Parameters
    const stationSimulationTableDownloadHeaders: string[] = useMapReleaseStore(
        (state) => state.getStationSimulationHeaders()
    );

    // Table Preferences
    const stationSimulationSummaryTablePreferences = useMapReleaseStore(
        (state) => state.stationSimulationSummaryTablePreferences
    );
    const setStationSimulationSummaryTablePreferences = useMapReleaseStore(
        (state) => state.setStationSimulationSummaryTablePreferences
    );

    type CustomFlashbarProps = {
        mapPackSummaryId: string | null;
    };
    const CustomFlashbar: React.FC<CustomFlashbarProps> = ({mapPackSummaryId}) => {
        return <Flashbar items={[
            {
                header: "Error",
                type: undefined,
                content: "Could not load station simulation summary for " + mapPackSummaryId,
                dismissible: false,
                dismissLabel: "Dismiss message",
                id: "message_1"
            }
        ]}/>;
    }

    useEffect(() => {
        if (mapPackSummaryId) {
            fetchStationSimulationSummary(mapPackSummaryId);
        }
    }, []); // Empty dependency array ensures the effect runs only once

    if (!mapPackSummaryId) {
        return <Layout> <Flashbar items={[{header: "Error", content: "Missing id parameter in the URL"}]}/> </Layout>;
    }

    return (
        <Layout>
            {isSimulationSummaryInvalid && isStationSimulationLoaded ? ([<CustomFlashbar
                    mapPackSummaryId={mapPackSummaryId}
                />, <br/>])
                : (!isStationSimulationLoaded ? ([
                        <Spinner size="large"/>,
                        <br/>, <br/>]
                ) : ([<ComplexFilterTable
                    itemList={stationSimulationData}
                    columnDefinitions={STATION_SIMULATION_SUMMARY_TABLE_COLUMN_DEFINITIONS}
                    visibleContentOptions={STATION_SIMULATION_SUMMARY_TABLE_VISIBLE_CONTENT_OPTIONS}
                    fetchingData={activeValidationDataFetchStatus}
                    pageSizeOptions={PAGE_SIZE_OPTIONS}
                    filterProperties={STATION_SIMULATION_SUMMARY_TABLE_FILTER_PROPERTIES}
                    preferences={stationSimulationSummaryTablePreferences}
                    setPreferences={setStationSimulationSummaryTablePreferences}
                    tableName={"Station Simulation Summary"}
                />, <br/>, <Button
                    onClick={() => downloadData(stationSimulationData, stationSimulationTableDownloadHeaders, "station_simulation_summary")}>
                    Download
                </Button>, <br/>, <br/>, <br/>]))}
            <br/>
        </Layout>
    );
};

export default StationSimulationSummary;